import React, { PureComponent } from "react";

export default class CR extends PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 0 512 341.338"
      >
        <g transform="translate(0 -85.331)">
          <rect
            width="512"
            height="341.326"
            transform="translate(0 85.331)"
            fill="#f0f0f0"
          />
          <rect
            width="512"
            height="89.043"
            transform="translate(0 211.473)"
            fill="#d80027"
          />
          <g>
            <rect
              width="512"
              height="74.207"
              transform="translate(0 352.462)"
              fill="#0052b4"
            />
            <rect
              width="512"
              height="74.207"
              transform="translate(0 85.331)"
              fill="#0052b4"
            />
          </g>
        </g>
      </svg>
    );
  }
}
